import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { Card } from '@comparethemarketau/manor-card';

const useStyles = createUseStyles((theme) => ({
    container: {
        display: 'block',
        border: 'unset'
    }
}));

const ContentCard = ({ children }) => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <Card
            className={classNames(classes.container)}
            margin={['0', '0', '24', '0']}
            padding={['24']}
            boxShadow
        >
            {
                children
            }
        </Card>
    );
};

ContentCard.propTypes = {
    children: PropTypes.node
};

export { ContentCard };
